<template>
    <MainContentSearchable 
        title="Listado de facturas" 
        id="facturas" 
        v-model="filters" 
        :meta="loading ? {} : facturas.meta" 
        @updated="debouncedGetFacturas"
    >
        <template #header>
            <div class="d-flex justify-content-between align-items-center w-100">
                <h4 class="pb-2">Facturas</h4>
                <Button @click="clearFilters" class="p-2 mb-2"><i class="fa fa-trash mr-1"></i> Limpiar filtros</Button>
            </div>
        </template>
        <template #extra-options>
            <div class="col-12 col-lg-9 pr-0 mr-0">
                <b-row class="input-group-sm my-3 mr-2 mr-md-0">
                    <b-col cols="12" lg="6">
                        <input
                            type="text"
                            class="form-control p-1 pl-0 mb-3 mb-md-0"
                            placeholder="Nº de factura"
                            v-model="filters.n_factura"
                            @input="debouncedGetFacturas"
                        />
                    </b-col>
                    <b-col cols="12" lg="6">
                        <select class="custom-select pr-0" v-model="filters.teatro_company_id" @change="debouncedGetFacturas">
                            <option value="">Compañía</option>
                            <option v-for="compania in companias" :value="compania.id" :key="compania.id">{{ compania.nombre }}</option>
                        </select>
                    </b-col>
                </b-row>
            </div>
            <b-row class="ml-0 ml-md-2 mr-0">
                <b-col cols="12" lg="3">
                    <label for="fecha_inicio">Fecha Inicio</label>
                    <input
                        type="date"
                        id="fecha_inicio"
                        name="fecha_inicio"
                        class="form-control p-1 mb-3 mb-md-0"
                        v-model="filters.fecha_inicio"
                        @input="debouncedGetFacturas"
                    />
                </b-col>
                <b-col cols="12" lg="3">
                    <label for="fecha_fin">Fecha Fin</label>
                    <input
                        type="date"
                        id="fecha_fin"
                        name="fecha_fin"
                        class="form-control p-1 mb-3 mb-md-0"
                        v-model="filters.fecha_fin"
                        @input="debouncedGetFacturas"
                    />
                </b-col>
                <b-col cols="12" lg="3" class="pr-2 pr-md-0">
                    <RangeSlider
                        label="Importes"
                        :min.sync="filters.importe_min"
                        :max.sync="filters.importe_max"
                        @getFacturas="debouncedGetFacturas"
                    />
                </b-col>
                <b-col cols="12" lg="3" class="pr-2 pr-md-0">
                    <RangeSlider
                        label="Base imponible"
                        :min.sync="filters.base_imponible_min"
                        :max.sync="filters.base_imponible_max"
                        @getFacturas="debouncedGetFacturas"
                    />
                </b-col>
            </b-row>
        </template>

        <template #content>
            <ContentOrLoading>
                <div class="table-responsive">
                    <b-table hover :items="facturas.data" :fields="fields" id="facturas-table">
                        <template #cell(iva)="{ item }">
                            {{ item.iva }} %
                        </template>
                        <template #cell(importe_total)="{ item }">
                            {{ item.importe_total | formatear_precio }}
                        </template>
                        <template #cell(base_imponible)="{ item }">
                            {{ item.base_imponible | formatear_precio }}
                        </template>
                        <template #cell(opciones)="{ item }">
                            <OpcionesDropdownTableComponent
                                v-bind:options="[
                                    { type: 'url', url: item.url_pdf, label: 'Descargar PDF' },
                                    { to: { name: 'back.facturas.show', params: { teatro_facturas_comisiones_id: item.id }}, label: 'Detalle' },
                                ]"
                            />
                        </template>
                    </b-table>
                </div>
            </ContentOrLoading>
        </template>
    </MainContentSearchable>
</template>

<script>
    import MainContentSearchable from '@/components/backend/components/MainContentSearchable';
    import RangeSlider from '@/components/backend/facturas/RangeSlider';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";

    export default {
        data() {
            return {
                facturas: { data: [], meta: { current_page: 1 } },
                loading: false,
                companias: [],
                fields: [
                    { key: "n_factura", label: "Nº de factura" },
                    { key: "iva", label: "IVA", class: 'text-center' },
                    { key: "fecha_inicio", label: "Fecha Inicio", class: 'text-center' },
                    { key: "fecha_fin", label: "Fecha Fin", class: 'text-center' },
                    { key: "importe_total", label: "Importe Total", class: 'text-center' },
                    { key: "base_imponible", label: "Base Imponible", class: 'text-center' },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ],
                filters: {
                    per_page: 10,
                    page: 1,
                    n_factura: '',
                    importe_min: 0,
                    importe_max: 5000,
                    base_imponible_min: 0,
                    base_imponible_max: 5000,
                    fecha_inicio: '',
                    fecha_fin: '',
                    teatro_company_id: ''
                }
            }
        },
        methods: {
            getFacturas() {
                this.loading = true;
            
                let params = {
                    filters: { ...this.filters },
                    teatro_id: this.teatro.id
                };

                if (params.filters.fecha_inicio) {
                    params.filters.fecha_inicio = this.formatDate(params.filters.fecha_inicio);
                }
                if (params.filters.fecha_fin) {
                    params.filters.fecha_fin = this.formatDate(params.filters.fecha_fin);
                }

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.facturas.index'), params).then(res => {
                    this.facturas = res.data;
                }).finally(() => this.loading = false);
            },
            getCompanias() {
                const params = {
                    filters : {},
                    teatro_id: this.teatro.id,
                    to_select: true
                };

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.compania-eventos.index'), params).then(res => {
                    this.companias = res.data.data;
                })
            },
            formatDate(date) {
                if (!date) return null;
                const d = new Date(date);
                const day = String(d.getDate()).padStart(2, '0');
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const year = d.getFullYear();
                return `${day}/${month}/${year}`;
            },
            clearFilters() {
                this.filters = {
                    per_page: 10,
                    page: 1,
                    n_factura: '',
                    importe_min: 0,
                    importe_max: 5000,
                    base_imponible_min: 0,
                    base_imponible_max: 5000,
                    fecha_inicio: '',
                    fecha_fin: '',
                    teatro_company_id: ''
                }

                this.getFacturas();
            }
        },
        created() {
            this.getFacturas();
            this.getCompanias();
            this.debouncedGetFacturas = _.debounce(this.getFacturas, 500);
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        components: {
            MainContentSearchable, RangeSlider, OpcionesDropdownTableComponent
        }
    }
</script>
